import type {
  FollowUpEvaluationResponse,
  FollowUpPhaseResponse,
  FollowUpSkillItemResponse,
} from '@lms/shared'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { groupSkillItemsByCategory } from '@/lib/skill-check'

interface SkillCheckScoreTableProps {
  skillItems: FollowUpSkillItemResponse[]
  evaluations: FollowUpPhaseResponse['evaluations']
}

function ScoreCell({
  evaluation,
  itemCode,
}: {
  evaluation: FollowUpEvaluationResponse | null
  itemCode: string
}) {
  if (!evaluation) return <span className="text-muted-foreground">未提出</span>
  if (evaluation.status === 'returned') return <span className="text-amber-600">差し戻し中</span>
  // 閲覧権限が無い評価は点数が返らない
  if (!evaluation.scores) return <span className="text-muted-foreground">提出済</span>

  const score = evaluation.scores.find((s) => s.itemCode === itemCode)?.score
  return <span className="font-semibold tabular-nums">{score ?? '-'}</span>
}

export function SkillCheckScoreTable({ skillItems, evaluations }: SkillCheckScoreTableProps) {
  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>スキルチェック項目</TableHead>
            <TableHead className="w-20 text-center">本人</TableHead>
            <TableHead className="w-20 text-center">上司</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {groupSkillItemsByCategory(skillItems).flatMap((group) => [
            <TableRow key={group.category} className="bg-muted/50 hover:bg-muted/50">
              <TableCell colSpan={3} className="text-sm font-semibold">
                {group.category}
              </TableCell>
            </TableRow>,
            ...group.items.map((item) => (
              <TableRow key={item.code}>
                <TableCell className="text-sm">{item.label}</TableCell>
                <TableCell className="text-center text-sm">
                  <ScoreCell evaluation={evaluations.self} itemCode={item.code} />
                </TableCell>
                <TableCell className="text-center text-sm">
                  <ScoreCell evaluation={evaluations.supervisor} itemCode={item.code} />
                </TableCell>
              </TableRow>
            )),
          ])}
        </TableBody>
      </Table>
    </div>
  )
}
